import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import './styles.scss'

const LongTextCellRenderer = ({ value }: ICellRendererParams): ReactElement => {
  return (
    <div className="long-text-cell-renderer-component">
      <span>{value}</span>
    </div>
  )
}

export default LongTextCellRenderer
